import {
  Row,
  Col,
  Tag,
  Button,
  Popconfirm,
  Flex,
  Tooltip,
  message,
  Typography,
  Space,
  Card,
  Collapse,
  Badge,
} from "antd"
import { GetCityWithSection } from "hooks/returnCityName"
import { Link } from "react-router-dom/cjs/react-router-dom"
import {
  ArrowRightOutlined,
  CopyOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  UserOutlined,
  PhoneOutlined,
  CalendarOutlined,
  HomeOutlined,
  EnvironmentOutlined,
  ToolOutlined,
  SafetyOutlined,
  FileTextOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons"
import "./column.scss"
import { SubmitFirstSupervision } from "./SubmitFirstSupervision"
import ResetPackage from "./ResetPackage"

const { Text } = Typography



export const renderFirstSupervisionButton = (params, { props }) => {
  return params.projectLevel === 7 ? (
    <SubmitFirstSupervision rowData={params} mainProps={props} />
  ) : (
    <>-----</>
  )
}

export const renderResetPackageButton = (row, { props, setErrorMessage }) => {
  return (
    <ResetPackage
      rowData={row}
      mainProps={props}
      setErrorMessage={setErrorMessage}
    />
  )
}

export const renderAcceptedButton = (params, { props }) => {
  return !params.accepted ? (
    <Flex vertical gap={8} style={{ width: "100%" }}>
      <Popconfirm
        title={
          <Text strong>
            قبول پرونده: {params.gasProject.fileNumber}
          </Text>
        }
        description={
          <Text type="secondary" style={{ fontSize: 12 }}>
            بعد از قبول این پرونده به مدت 72 ساعت جهت تعیین تکلیف آن مهلت دارید
          </Text>
        }
        onConfirm={() =>
          props.onAcceptedProjectProcess({ gppId: params.id, accepted: true })
        }
        okText="قبول میکنم"
        cancelText="بستن"
        okButtonProps={{
          style: {
            background: "linear-gradient(135deg, #52c41a 0%, #389e0d 100%)",
            border: "none",
          },
        }}
      >
        <Button
          type="primary"
          size="small"
          icon={<CheckCircleOutlined />}
          style={{
            width: "100%",
            background: "linear-gradient(135deg, #52c41a 0%, #389e0d 100%)",
            border: "none",
            borderRadius: 6,
            boxShadow: "0 2px 8px rgba(82, 196, 26, 0.3)",
          }}
          disabled={params.inspectionStatus !== 0}
        >
          قبول
        </Button>
      </Popconfirm>

      <Popconfirm
        title={
          <Text strong>
            رد پرونده: {params.gasProject.fileNumber}
          </Text>
        }
        description={
          <Text type="secondary" style={{ fontSize: 12 }}>
            آیا از رد این پرونده اطمینان دارید؟
          </Text>
        }
        onConfirm={() =>
          props.onAcceptedProjectProcess({ gppId: params.id, accepted: false })
        }
        okText="رد پرونده"
        cancelText="بستن"
        okButtonProps={{ danger: true }}
      >
        <Button
          type="primary"
          size="small"
          danger
          icon={<CloseCircleOutlined />}
          style={{
            width: "100%",
            borderRadius: 6,
          }}
          disabled={params.inspectionStatus !== 0}
        >
          رد
        </Button>
      </Popconfirm>
    </Flex>
  ) : (
    <Tag
      color={params.accepted ? "success" : "error"}
      icon={params.accepted ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
      style={{ borderRadius: 6, padding: "2px 8px" }}
    >
      {params.solarDateAccepted}
    </Tag>
  )
}

export const renderFloorNumber = params => {
  if (params.floorNumber == 0 && params.unitNumber == 1)
    return <Tag color="cyan" style={{ borderRadius: 4, margin: 0 }}>همکف</Tag>
  if (params.floorNumber == 0 && params.unitNumber > 1)
    return <Tag color="purple" style={{ borderRadius: 4, margin: 0 }}>چند واحدی</Tag>
  return <Tag style={{ borderRadius: 4, margin: 0 }}>{params.floorNumber}</Tag>
}

export const renderProjectUpdateButton = (params, { props }) => {
  return (
    <Flex align="center" justify="center" gap={4}>
      <Link to={`/projects/GasProjectProcessEng/${params?.id}`}>
        <Button
          type="link"
          size="small"
          style={{
            padding: "4px 8px",
            height: "auto",
            borderRadius: 6,
            background: "linear-gradient(135deg, #667eea15 0%, #764ba215 100%)",
            border: "1px solid #667eea30",
          }}
        >
          <Flex align="center" gap={4}>
            <Text strong style={{ color: "#667eea", fontSize: 13 }}>
              {params.fileNumber}
            </Text>
            <ArrowRightOutlined style={{ fontSize: 12, color: "#667eea" }} />
          </Flex>
        </Button>
      </Link>
      <Tooltip title="کپی شماره پرونده">
        <Button
          type="text"
          icon={<CopyOutlined style={{ color: "#8c8c8c" }} />}
          size="small"
          style={{ borderRadius: 6 }}
          onClick={() => {
            navigator.clipboard.writeText(params.fileNumber)
            message.success("شماره پرونده کپی شد")
          }}
        />
      </Tooltip>
    </Flex>
  )
}

export const renderRowNumber = (index, { pageIndex, pageSize }) => {
  return (pageIndex - 1) * pageSize + index + 1
}

export const renderAllColumn = (params, props) => {
  const collapseItems = [
    {
      key: params.fileNumber,
      label: (
        <Flex align="center" gap={8}>
          <UserOutlined style={{ color: "#667eea" }} />
          <Text style={{ fontSize: 12 }}>
            مجری: {params.executorName} | {params.executorCellPhone}
          </Text>
        </Flex>
      ),
      children: (
        <Row gutter={[8, 8]}>
          <Col span={12}>
            <Flex align="center" gap={4}>
              <HomeOutlined style={{ color: "#8c8c8c", fontSize: 12 }} />
              <Text type="secondary" style={{ fontSize: 11 }}>طبقه:</Text>
              {renderFloorNumber(params)}
            </Flex>
          </Col>
          <Col span={12}>
            <Flex align="center" gap={4}>
              <HomeOutlined style={{ color: "#8c8c8c", fontSize: 12 }} />
              <Text type="secondary" style={{ fontSize: 11 }}>واحد:</Text>
              <Tag style={{ borderRadius: 4, margin: 0 }}>{params.unitNumber}</Tag>
            </Flex>
          </Col>
          <Col span={24}>
            <Flex align="center" gap={4}>
              <SafetyOutlined style={{ color: "#8c8c8c", fontSize: 12 }} />
              <Text type="secondary" style={{ fontSize: 11 }}>نوع بازرسی:</Text>
              <Text style={{ fontSize: 12 }}>{params.inspectionTypeName}</Text>
            </Flex>
          </Col>
          <Col span={24}>
            <Flex align="center" gap={4}>
              <FileTextOutlined style={{ color: "#8c8c8c", fontSize: 12 }} />
              <Text type="secondary" style={{ fontSize: 11 }}>پارامتر:</Text>
              <Text style={{ fontSize: 12 }}>{params.inspectionParameterTypeName}</Text>
            </Flex>
          </Col>
          <Col span={24}>
            <Flex align="center" gap={4}>
              <ToolOutlined style={{ color: "#8c8c8c", fontSize: 12 }} />
              <Text type="secondary" style={{ fontSize: 11 }}>لوله کشی:</Text>
              <Tag color={params.pipingTypeName === "روکار" ? "default" : "gold"} style={{ borderRadius: 4, margin: 0 }}>
                {params.pipingTypeName}{params.hasBurial?(<Text color="brown">دفنی</Text>):''}
              </Tag>
            </Flex>
          </Col>
          <Col span={24}>
            <Flex align="center" gap={4}>
              <ExclamationCircleOutlined style={{ color: "#8c8c8c", fontSize: 12 }} />
              <Text type="secondary" style={{ fontSize: 11 }}>وضعیت:</Text>
              <Tag color={params.inspectionStatus === 1 ? "success" : "error"} style={{ borderRadius: 4, margin: 0 }}>
                {params.inspectionStatusName}
              </Tag>
            </Flex>
          </Col>
          <Col span={24}>
            <Flex align="center" gap={4}>
              <SafetyOutlined style={{ color: "#8c8c8c", fontSize: 12 }} />
              <Text type="secondary" style={{ fontSize: 11 }}>پکیج/آبگرمکن:</Text>
              <Tag color={params.packageNeed ? "blue" : "default"} style={{ borderRadius: 4, margin: 0 }}>
                {params.packageNeed ? "نیاز دارد" : "نیاز ندارد"}
              </Tag>
            </Flex>
          </Col>
        </Row>
      ),
    },
  ]

  return (
    <Card
      size="small"
      style={{
        borderRadius: 8,
        border: "1px solid #f0f0f0",
        boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
      }}
      bodyStyle={{ padding: 8 }}
    >
      <Row gutter={[8, 8]}>
        {props.projectLevel !== 0 && (
          <>
            <Col span={24}>{renderProjectUpdateButton(params, props)}</Col>

            {(props.projectLevel === 7 || props.projectLevel === 6) && (
              <Col span={12}>
                {renderCheckListRequired(params, props)}
              </Col>
            )}

            <Col span={12}>
              {renderDesignButton(params, props)}
            </Col>
            <Col span={12}>
              {renderSupervisionButton(params, props)}
            </Col>
            <Col span={12}>
              {renderFirstSupervisionButton(params, props)}
            </Col>
          </>
        )}

        <Col span={24}>
          <Flex align="center" gap={4}>
            <UserOutlined style={{ color: "#667eea", fontSize: 12 }} />
            <Text type="secondary" style={{ fontSize: 11 }}>مالک:</Text>
            <Text strong style={{ fontSize: 12 }}>{params.gasProjectDetail.gasProject.landlordName}</Text>
          </Flex>
        </Col>

        <Col span={24}>
          <Flex align="center" gap={4}>
            <CalendarOutlined style={{ color: "#52c41a", fontSize: 12 }} />
            <Text type="secondary" style={{ fontSize: 11 }}>تخصیص:</Text>
            <Tag color="green" style={{ borderRadius: 4, margin: 0, fontSize: 11 }}>
              {params.solarDateDeliverEngineer}
            </Tag>
          </Flex>
        </Col>

        <Col span={24}>
          <Flex align="center" gap={4}>
            <CalendarOutlined style={{ color: "#1890ff", fontSize: 12 }} />
            <Text type="secondary" style={{ fontSize: 11 }}>تایید:</Text>
            <Tag color="blue" style={{ borderRadius: 4, margin: 0, fontSize: 11 }}>
              {params.solarDateDeliverOffice || "-"}
            </Tag>
          </Flex>
        </Col>

        <Col span={24}>
          <Collapse
            ghost
            size="small"
            items={collapseItems}
            style={{
              background: "#fafafa",
              borderRadius: 6,
            }}
          />
        </Col>
      </Row>
    </Card>
  )
}
export const projectColumnsAnt = props => {
  return [
    {
      title: (
        <Flex align="center" gap={4}>
          <FileTextOutlined style={{ color: "#667eea" }} />
          <span>شماره پرونده</span>
        </Flex>
      ),
      key: "fileNumber",
      render: params => renderProjectUpdateButton(params, props),
      hidden: false,
      width: 140,
      fixed: "right",
    },
    {
      title: (
        <Flex align="center" gap={4}>
          <CheckCircleOutlined style={{ color: "#52c41a" }} />
          <span>اقدامات</span>
        </Flex>
      ),
      key: "accepted",
      render: params => renderAcceptedButton(params, props),
      hidden: props.projectLevel !== 4,
      width: 125,
    },
    {
      title: (
        <Flex align="center" gap={4}>
          <UserOutlined style={{ color: "#1890ff" }} />
          <span>نام مالک</span>
        </Flex>
      ),
      key: "landLordName",
      render: params => (
        <Text style={{ fontSize: 13 }}>{params.landLordName}</Text>
      ),
      hidden: false,
      width: 120,
    },
    {
      title: (
        <Flex align="center" gap={4}>
          <SafetyOutlined style={{ color: "#722ed1" }} />
          <span>پکیج</span>
        </Flex>
      ),
      key: "package",
      render: params => (
        <Flex vertical gap={4} align="center">
          {renderResetPackageButton(params, props)}
          {params.packageNeed && params.packageSerialNumber && (
            <Tag color="purple" style={{ borderRadius: 4, fontSize: 11 }}>
              {params.packageSerialNumber}
            </Tag>
          )}
        </Flex>
      ),
      hidden: props.projectLevel !== 5,
      width: 100,
    },
    {
      title: (
        <Flex align="center" gap={4}>
          <ExclamationCircleOutlined style={{ color: "#faad14" }} />
          <span>وضعیت</span>
        </Flex>
      ),
      key: "inspectionStatus",
      render: params => (
        <Flex vertical gap={4} align="center">
          <Tag
            color={params.inspectionStatus === 1 ? "success" : "error"}
            icon={params.inspectionStatus === 1 ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
            style={{ borderRadius: 6, margin: 0 }}
          >
            {params.inspectionStatusName}
          </Tag>
          {params.defect && (
            <Tag color="warning" style={{ borderRadius: 4, margin: 0, fontSize: 10 }}>
              +نقص
            </Tag>
          )}
        </Flex>
      ),
      width: 100,
      hidden: false,
    },
    {
      title: (
        <Flex align="center" gap={4}>
          <UserOutlined style={{ color: "#13c2c2" }} />
          <span>مجری</span>
        </Flex>
      ),
      key: "executorName",
      render: row => (
        <Flex vertical gap={4} align="center">
          <Tag
            icon={<UserOutlined />}
            style={{ borderRadius: 4, margin: 0, fontSize: 11 }}
          >
            {row.executorName}
          </Tag>
          <Tag
            icon={<PhoneOutlined />}
            color="cyan"
            style={{ borderRadius: 4, margin: 0, fontSize: 11 }}
          >
            {row.executorCellPhone}
          </Tag>
        </Flex>
      ),
      hidden: false,
      width: 120,
    },
    {
      title: (
        <Flex align="center" gap={4}>
          <CalendarOutlined style={{ color: "#52c41a" }} />
          <span>تاریخ تخصیص</span>
        </Flex>
      ),
      key: "solarDateDeliverEngineer",
      render: params => (
        <Flex vertical gap={4} align="center">
          <Tag color="green" style={{ borderRadius: 4, margin: 0, fontSize: 11 }}>
            {params.solarDateDeliverEngineer}
          </Tag>
          <Tag style={{ borderRadius: 4, margin: 0, fontSize: 10 }}>
            {params.inspectionTypeName}
          </Tag>
        </Flex>
      ),
      hidden: false,
      width: 110,
    },
    {
      title: (
        <Flex align="center" gap={4}>
          <HomeOutlined style={{ color: "#eb2f96" }} />
          <span>واحد/طبقه</span>
        </Flex>
      ),
      key: "unitNumber",
      render: params => (
        <Flex vertical gap={4} align="center">
          <Tooltip title="واحد">
            <Tag color="magenta" style={{ borderRadius: 4, margin: 0 }}>
              {params.unitNumber}
            </Tag>
          </Tooltip>
          <Tooltip title="طبقه">
            {renderFloorNumber(params)}
          </Tooltip>
        </Flex>
      ),
      hidden: false,
      width: 90,
    },
    {
      title: (
        <Flex align="center" gap={4}>
          <EnvironmentOutlined style={{ color: "#fa541c" }} />
          <span>شهر</span>
        </Flex>
      ),
      key: "section",
      render: row => {
        let returnValue = "-"
        if (row.idSection > 0) {
          returnValue = GetCityWithSection(row.idSection)
        }
        return (
          <Tag color="orange" style={{ borderRadius: 4 }}>
            {returnValue}
          </Tag>
        )
      },
      width: 80,
    },
    {
      title: (
        <Flex align="center" gap={4}>
          <ToolOutlined style={{ color: "#2f54eb" }} />
          <span>مشخصات</span>
        </Flex>
      ),
      key: "solarRegisterDate",
      render: row => (
        <Flex vertical gap={4} align="center">
          <Tag style={{ borderRadius: 4, margin: 0, fontSize: 10 }}>
            {row.inspectionParameterTypeName}
          </Tag>
          <Tag
            color={row.pipingTypeName === "روکار" ? "default" : "gold"}
            style={{ borderRadius: 4, margin: 0, fontSize: 10 }}
          >
            {row.pipingTypeName}
          </Tag>
          <Tag
            color={
              row.buildingTypeName === "تجاری"
                ? "cyan"
                : row.buildingTypeName === "صنعتی"
                ? "volcano"
                : "default"
            }
            style={{ borderRadius: 4, margin: 0, fontSize: 10 }}
          >
            {row.buildingTypeName}
          </Tag>
        </Flex>
      ),
      width: 100,
    },
    {
      title: (
        <Flex align="center" gap={4}>
          <CalendarOutlined style={{ color: "#1890ff" }} />
          <span>تاریخ تایید</span>
        </Flex>
      ),
      key: "solarDateDeliverOffice",
      render: row => (
        row.solarDateDeliverOffice ? (
          <Tag color="blue" style={{ borderRadius: 4 }}>
            {row.solarDateDeliverOffice}
          </Tag>
        ) : (
          <Text type="secondary">-</Text>
        )
      ),
      width: 90,
      hidden: props.projectLevel === 4,
    },
  ]
    .filter(item => !item.hidden)
    .filter(item => props.filterColumn?.indexOf(item.title) === -1)
}
